export const NonEnroledDeductionTable = () => {
  return [
    {
      field: 'sl_no',
      headerName: 'SL.No',
      width: 80,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'student_name',
      headerName: 'Lead Name',
      width: 220,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'admn_no',
      headerName: 'Lead ID',
      width: 130,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'sale_amount',
      headerName: 'Total Sale Amount',
      width: 200,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'collected_amount',
      headerName: 'Fee Collected',
      width: 180,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'refunded_amount',
      headerName: 'Refunded Amount',
      width: 180,
      headerAlign: 'center',
      align: 'center',
    },
  ];
};
